

import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class RemoveButton extends Vue {
  @Prop({ required: false }) href!: string
  @Prop({ default: () => Vue.prototype.$gettext('Remove') }) tooltip!: string
  @Prop({ default: false }) disabled!: boolean
}
